import React, { useEffect, useState } from "react";
import {
  Row,
  Col,
  Container,
  Dropdown,
  Form,
  Tab,
  Nav,
  Button,
  OverlayTrigger,
  Tooltip,
  Modal,
} from "react-bootstrap";
import { Link } from "react-router-dom";
import Card from "../../../components/Card";
import CustomToggle from "../../../components/dropdowns";
import ShareOffcanvas from "../../../components/share-offcanvas";
import { MuiFileInput } from "mui-file-input";
// import {Row, Col, Container, Form, Button, Image} from 'react-bootstrap'
import moment from "moment";
//image
import user1 from "../../../assets/images/user/1.jpg";
import user01 from "../../../assets/images/user/01.jpg";
import user2 from "../../../assets/images/user/02.jpg";
import user3 from "../../../assets/images/user/03.jpg";
import user4 from "../../../assets/images/user/04.jpg";
import img1 from "../../../assets/images/small/07.png";
import img2 from "../../../assets/images/small/08.png";
import img3 from "../../../assets/images/small/09.png";
import img4 from "../../../assets/images/small/10.png";
import img5 from "../../../assets/images/small/11.png";
import img6 from "../../../assets/images/small/12.png";
import img7 from "../../../assets/images/small/13.png";
import img8 from "../../../assets/images/small/14.png";
import p1 from "../../../assets/images/page-img/p1.jpg";
import s1 from "../../../assets/images/page-img/s1.jpg";
import s2 from "../../../assets/images/page-img/s2.jpg";
import s3 from "../../../assets/images/page-img/s3.jpg";
import s4 from "../../../assets/images/page-img/s4.jpg";
import s5 from "../../../assets/images/page-img/s5.jpg";
import p2 from "../../../assets/images/page-img/p2.jpg";
import p3 from "../../../assets/images/page-img/p3.jpg";
import p4 from "../../../assets/images/page-img/p4.jpg";
import p5 from "../../../assets/images/page-img/p5.jpg";
import img42 from "../../../assets/images/page-img/42.png";
import icon1 from "../../../assets/images/icon/01.png";
import icon2 from "../../../assets/images/icon/02.png";
import icon3 from "../../../assets/images/icon/03.png";
import icon4 from "../../../assets/images/icon/04.png";
import icon5 from "../../../assets/images/icon/05.png";
import icon6 from "../../../assets/images/icon/06.png";
import icon7 from "../../../assets/images/icon/07.png";
import img9 from "../../../assets/images/small/img-1.jpg";
import img10 from "../../../assets/images/small/img-2.jpg";
import loader from "../../../assets/images/page-img/page-load-loader.gif";
import axios from "axios";
import toast, { Toaster } from 'react-hot-toast';
import "./Style.css";
import InfiniteScroll from "react-infinite-scroll-component";
import { IoIosArrowDown, IoIosArrowUp } from "react-icons/io";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import { getToken } from "../../../utils/auth";
import { useNavigate } from "react-router-dom";
import useAuth from "../../../utils/useAuth";
import Sponsored from "../Sponsored";
import { MdOutlineDone } from "react-icons/md";
import { Carousel } from "react-responsive-carousel";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import { CiMail } from "react-icons/ci";
import { IoCallOutline } from "react-icons/io5";
import { CiGlobe } from "react-icons/ci";
import { BsPatchCheckFill } from "react-icons/bs";
import Sponsored1 from "../Sponsored1";
import { useTranslation } from "react-i18next";
import { CircularProgress } from "@mui/material";
import { useUser } from "../../../Context/UserContext";
import { Country, State } from 'country-state-city';
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';
import validatePhoneNumber from "../../../utils/validatePhoneNumber";
import validateEmail from "../../../utils/validateEmail";

const ForSale = () => {
  useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (!getToken()) {
      navigate("/auth/sign-in");
    }
  }, []);
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const [loadingFull, setLoadingFull] = useState(false);
  const [description, setDescription] = useState("");
  const [selectedFile, setSelectedFile] = useState([]);
  const [expandedRows, setExpandedRows] = useState({});
  const { t, i18n } = useTranslation();
  const [formData, setFormData] = useState({
    title: "",
    description: "",
    address: "",
    city: "",
    state: "",
    zipCode: "",
    country:"",
    condition: "new",
    price: "",
    saleCategory: "Estate",
    mobile: "",
    email: "",
});
  const [countryName, setCountryName] = useState("")

  // useEffect(() => {
  //   console.log("formData", formData);
  // }, [formData]);

  const [showModal, setShowModal] = useState(false);
  const [contactInfo, setContactInfo] = useState({
    email: '',
    phone: ''
  });

  const handleOpenModal = (data) => {
    setContactInfo({
      email: data?.email,
      phone: data?.mobile
    });
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
  };

  
  const toggleExpand = (index) => {
    setExpandedRows((prevExpandedRows) => ({
      ...prevExpandedRows,
      [index]: !prevExpandedRows[index],
    }));
  };

  const handleChange = (e) => {
    const { name, value } = e.target;

      setFormData({
        ...formData,
        [name]: value,
      });
    
  };
  const [categorypost, setCategorypost] = useState("public");

  const handleCategoryChange = (e) => {
    setCategorypost(e.target.value);
  };
  const [post, setPost] = useState([]);
  const [page, setPage] = useState(1);
  // const [hasMore, setHasMore] = useState(true);
  const [totalPages, setTotalPages] = useState(1);
  const [postType, setPostType] = useState("");
  const [entertainment, setEntertainment] = useState([]);
  const [entries, setEntries] = useState("");
  const handleAllPost = async (updateData = false) => {
    try {
      const token = getToken();
      let url = `${process.env.REACT_APP_URL}/api/post/category/all?page=${page}&limit=5&category=for-sale`;
      if (postType) {
        url += `&searchFor=${postType}&country=${countryName}`;
      }
      const response = await axios.get(url,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            // "Content-Type": "multipart/form-data",
          },
        }
      );
      // console.log("For Sale Fetched Successfully",response.data.data.allPosts);
      if (updateData) {
        setEntertainment(response.data.data.allPosts);
      } else {
        setEntertainment((prevPost) => [...prevPost, ...response.data.data.allPosts]);
      }
      // setHasMore(response.data.data.allPosts.length > 0);
      setTotalPages(response.data.data.noOfEntries%5===0?response.data.data.noOfEntries/5:parseInt(response.data.data.noOfEntries/5)+1);

    } catch (error) {
      console.log("Failed Fetching For Sale", error);
    }
  };

  // useEffect(() => {
  //   handleAllPost();
  // }, [page]);
  useEffect(() => {
    if(page===1)
      {
        handleAllPost(true)
      }else{
        handleAllPost();
      }
  }, [page,postType]);

  const [upcoming, setUpcoming] = useState([]);
  const handleUpcoming = async () => {
    try {
      const token = getToken();
      const response = await axios.get(
        `${process.env.REACT_APP_URL}/api/event/upcoming/all`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            // "Content-Type": "multipart/form-data"
          },
        }
      );
      // console.log(
      //   "Upcoming Event Fetched Successfully",
      //   response.data.data.allEvents
      // );
      setUpcoming(response.data.data.allEvents);
    } catch (error) {
      console.log("Failed Fetching Upcoming Event", error);
    }
  };

  useEffect(() => {
    handleUpcoming();
  }, []);

    const handleVisitCount = async () => {
      try {
          const token = getToken();
          const response = await axios.post(
              `${process.env.REACT_APP_URL}/api/stats/module`,
              {
                  moduleType: "deals"
              }, {
              headers: {
                  "Authorization": `Bearer ${token}`,
                  "Content-Type": "application/json"
              }
          }
          );
          
      } catch (error) {
          console.error('Failed Visit count', error);
      }
  
  }
  useEffect(()=>{
      handleVisitCount();
  },[])
   const { userData } = useUser();
   const profileImage = userData?.profileImageLink ? userData?.profileImageLink : "/profile.png";


    const [imagePreview, setImagePreview] = useState(null);

    const handleFileInputChange = (event) => {
      const files = Array.from(event.target.files);
      setSelectedFile(files);
      const previews = files.map(file => URL.createObjectURL(file));
      setImagePreview(previews);
      toast.success("File selected!");
  };
 
  const [photos, setPhotos] = useState([]);
  const handlePost = async () => {
    const MAX_SIZE = 1 * 1024 * 1024;
    for (let i = 0; i < selectedFile.length; i++) {
      if (selectedFile[i].size > MAX_SIZE) {
        toast.error(`File size must not exceed 1MB`);
        return;
      }
    }
    if (!formData.title || !description ||        
      !formData.address ||
      !formData.city ||
      !formData.state ||
      !formData.country ||
      !formData.zipCode || !formData.condition || !formData.saleCategory || !formData.mobile || !formData.email || !selectedFile) {
      toast.error("Please fill required fields");
      return;
    }
          if (selectedFile.length === 0) {
    toast.error("Please select at least one image.");
    return;
  }
    try {
      setLoadingFull(true)
const token = getToken();
      const formData = new FormData();
      for (let i = 0; i < selectedFile.length; i++) {
        formData.append("files", selectedFile[i]);
      }

      const uploadResponse = await axios.post(
        `${process.env.REACT_APP_URL}/api/file/upload/multiple`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      // console.log("oath", uploadResponse.data.data);

      setPhotos(uploadResponse.data.data);
      postPhoto(uploadResponse.data.data);

      //   setShow(false);
    } catch (error) {
      console.log("Failed to create post:", error);
      toast.error(
        error?.uploadResponse?.data?.message || "Failed to Upload Image/Video"
      );
    } finally{
      setLoadingFull(false)

    }
  };

  const postPhoto = async (photoss) => {
    if (!formData.title || !description  ||
      !formData.address ||
      !formData.city ||
      !formData.state ||
      !formData.country ||
      !formData.zipCode || !formData.condition || !formData.saleCategory || !formData.mobile || !formData.email || photoss.length === 0) {
      toast.error("Please fill required fields");
      return;
    }
    
        setLoadingFull(true)
    
      if (!(await validateEmail(formData.email))) {
        toast.error("Invalid Email");
            setLoadingFull(false)
        return;
      }
    
      if (!(await validatePhoneNumber(formData.mobile))) {
        toast.error("Invalid phone number.");
            setLoadingFull(false)
        return;
      }
    try {
      setLoadingFull(true)
const token = getToken();
      const postData = {
        title:formData.title,
        description: description,
        location: {
          address: formData.address,
          city: formData.city,
          state: formData.state,
          zipCode: formData.zipCode,
          country: formData.country
        },
        condition:formData.condition,
        saleCategory:formData.saleCategory,
        mobile:formData.mobile,
        email:formData.email,
        title:formData.title,
        photos: photoss,
      };

      const postResponse = await axios.post(
        `${process.env.REACT_APP_URL}/api/post/for-sale`,
        postData,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      handleAllPost(true);
      // console.log("Post Successfully", postResponse.data);
      toast.success("Post created successfully");
      setDescription("");
      setSelectedFile([]);
      setFormData({
        title: "",
        address: "",
        city: "",
        state: "",
        zipCode: "",
        country: "",
        condition: "",
        saleCategory: "",
        mobile: "",
        email: ""
      });
      //   setShow(false);
    } catch (error) {
      toast.error(error?.response?.data?.message);
      console.log("Failed Posting ", error);
    } finally {
      setShow(false);
      setLoadingFull(false)

    }
  };


  const [user, setUser] = useState("");

  const fetchUserData = async () => {
    try {
      const token = getToken();
      const response = await axios.get(
        `${process.env.REACT_APP_URL}/api/user`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      // console.log("user details header", response.data.data);
      setUser(response?.data?.data);
      const countryCode = response?.data?.data?.country || "";
                  const countryInfo = Country.getCountryByCode(countryCode);
                  const countryNameFromList = countryInfo?.name || "";
                  setCountryName(countryNameFromList)
                  setFormData((prev) => ({ ...prev, country: countryNameFromList }));
    } catch (error) {
      console.error("Failed Fetching Details", error);
    }
  };
  useEffect(() => {
      fetchUserData();
  },[])


  const [dropdown, setDropdown] = useState();

  const handleDropdown = async () => {
    try {
      const token = getToken();
      const response = await axios.get(
        `${process.env.REACT_APP_URL}/api/default-setting`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      // console.log("Category Dropdown fetched", response.data.data.isDefaultSettingsExist);
      setDropdown(response.data.data.isDefaultSettingsExist);
    } catch (error) {
      console.error("Failed Fetching dropdown", error);
    }
  };
useEffect(()=>{
  handleDropdown();
},[]);

const getCountryCodeByName = (countryName) => {
  const country = Country.getAllCountries().find(
    (c) => c.name === countryName
  );
  return country?.isoCode || "";
};

const handlePhoneChange = (phone, field) => {
  setFormData((prev) => ({
    ...prev,
    [field]: phone,
  }));
};

  return (
    <>
<Toaster position="top-right" reverseOrder={false}/>
{loadingFull && (
    <div style={styles.loaderOverlay}>
      <CircularProgress style={{ color: "white" }} />
    </div>
  )}
<div id="content-page" className="content-page">
        <Container>
          <Row>
          <Col lg="12">
              <Tab.Container defaultActiveKey="f1">
                <Card className="cardnavbar">
                  <div className="user-tabing">
                    <Nav
                                         variant="pills"
                                         className="connection-tabs-nav p-0 m-0 round"
                                       >
                                         <Nav.Item as="li">
                                           <Nav.Link
                                             onClick={(e) => {
                                               setPostType("");
                                               setPage(1);
                                             }}
                                             className="text-center"
                                             eventKey="f1"
                                             href="#"
                                           >
                                             {t("my_posts")}
                                           </Nav.Link>
                                         </Nav.Item>
                   
                                         <Nav.Item as="li">
                                           <Nav.Link
                                             onClick={(e) => {
                                               setPostType("all");
                                               setPage(1);
                                             }}
                                             className="text-center"
                                             eventKey="f2"
                                             href="#"
                                           >
                                             {t("other_posts")}
                                           </Nav.Link>
                                         </Nav.Item>
                                       </Nav>
                  </div>
                </Card>
                <Tab.Content className="forum-content">
                  <Tab.Pane eventKey="f1">
                  <Col lg={12} className="row m-0 p-0">
              <Col sm={12}>
                <Card
                  id="post-modal-data"
                  className="card-block card-stretch card-height"
                >
                  <div className="card-header d-flex justify-content-between">
                    <div className="header-title">
                      <h4 className="card-title">{t('createPostForSale')}</h4>
                    </div>
                  </div>
                  <Card.Body>
                    <div className="d-flex align-items-center">
                      <div className="user-img">
                        <img
                        src={profileImage}
                          // src={`${user?.profileImageLink ? user?.profileImageLink : '/profile.png'}`}
                          alt="user1"
                          className="avatar-60 rounded-circle"
                        />
                      </div>
                      <form
                        className="post-text ms-3 w-100 "
                        onClick={handleShow}
                      >
                        <input
                          type="text"
                          className="form-control rounded"
                          placeholder={t('writeSomethingHere')}
                          style={{ border: "none" }}
                        />
                      </form>
                    </div>
                    
                  </Card.Body>
                  <Modal
                    size="lg"
                    className="fade"
                    id="post-modal"
                    onHide={handleClose}
                    show={show}
                    style={{ marginTop: "100px", maxHeight: "80vh" }}
                  >
                    <Modal.Header className="d-flex justify-content-between">
                      <Modal.Title id="post-modalLabel">
                        {t('createPostForSale')}
                      </Modal.Title>
                      <Link to="#" className="lh-1" onClick={handleClose}>
                        <span className="material-symbols-outlined">close</span>
                      </Link>
                    </Modal.Header>
                    <Modal.Body>
                      <div className="d-flex align-items-center">
                        {/* <div className="user-img">
                                                    <img src={profileImage} alt="user1" className="avatar-60 rounded-circle img-fluid" />
                                                </div> */}
                        <form
                          className="post-text ms-3 w-100 "
                          data-bs-toggle="modal"
                          data-bs-target="#post-modal"
                        >
                          {/* <input type="text" className="form-control rounded" placeholder={t('whats_on_your_mind')} style={{border:"none"}} onChange={(e)=> setDescription(e.target.value)}/> */}
                          {/* <EmojiPicker /> */}
                          {/* <br /> */}
                        </form>
                      </div>
                      {/* <hr /> */}
                      <ul className="d-flex flex-wrap align-items-center list-inline m-0 p-0 ">
                        <li className="col-12 mb-1 ">
                          <Form.Group className="form-group">
                            <Form.Label>
                            {t('title')} <span style={{ color: "red" }}>*</span>{" "}
                            </Form.Label>
                            <Form.Control
                              type="text"
                              name="title"
                              value={formData.title}
                              onChange={handleChange}
                              className="mb-0 py-2"
                              id=""
                              placeholder={t('enterTitle')}
                              required
                            />
                          </Form.Group>
                        </li>
                       
                        <li className="col-12 mb-3">
                          <Form.Label>
                          {t('description')} <span style={{ color: "red" }}>*</span>{" "}
                          </Form.Label>
                          <CKEditor
                            editor={ClassicEditor}
                            data=""
         config={{
    toolbar: [
      'heading', '|',
      'bold', 'italic', 'link', 'bulletedList', 'numberedList', 'blockQuote', '|',
      'undo', 'redo'
    ],
    removePlugins: ['ImageUpload', 'MediaEmbed', 'EasyImage'],
          placeholder: t('whats_on_your_mind'),

  }}
                            onChange={(event, editor) => {
                              const data = editor.getData();
                              setDescription(data);
                            }}
                          />
                        </li>
                      
                        <li className="col-12 mb-1 ">
                          <Form.Group className="form-group">
                            <Form.Label>
                              {t('condition')} <span style={{ color: "red" }}>*</span>{" "}
                            </Form.Label>
                            <Form.Select
                              name="condition"
                              value={formData.condition}
                              onChange={handleChange}
                              className="mb-0 py-2"
                              required
                            >
                                                            <option value="">Select Condition</option>

                               {dropdown?.condition?.map((category, index) => (
                                  <option key={index} value={category}>
                                    {category}
                                  </option>
                                ))}
                              {/* <option value="new">{t('new')}</option>
                              <option value="used">{t('used')}</option> */}
                            </Form.Select>
                          </Form.Group>
                        </li>
                        <li className="col-12 mb-1 ">
                          <Form.Group className="form-group">
                            <Form.Label>
                            {t('price')} <span style={{ color: "red" }}>*</span>{" "}
                            </Form.Label>
                            <Form.Control
                              type="tel"
                              maxLength={10}                              name="price"
                                                            value={formData.price}
                                                                  onChange={(e) => {
                                                                     const re = /^[0-9\b]+$/;
                                                                     if (e.target.value === '' || re.test(e.target.value)) {
                                                                        setFormData(prevState => ({
                                                                           ...prevState,
                                                                           price: e.target.value
                                                                        }));
                                                                     }
                                                                  }}
                             
                              className="mb-0 py-2"
                              id=""
                              placeholder={t('price')}
                              required
                            />
                          </Form.Group>
                        </li>
                        <li className="col-12 mb-1 ">
                          <Form.Group className="form-group">
                            <Form.Label>
                              {t('saleCategory')}{" "}
                              <span style={{ color: "red" }}>*</span>{" "}
                            </Form.Label>
                            <Form.Control
                              as="select"
                              name="saleCategory"
                              value={formData.saleCategory}
                              onChange={handleChange}
                              className="mb-0 py-2"
                              required
                            >
                              <option value="">{t('select_a_category')}</option>
                              {dropdown?.saleCategory?.map((category, index) => (
                                <option key={index} value={category}>
                                  {category}
                                </option>
                              ))}
                            </Form.Control>
                          </Form.Group>
                        </li>

                                    <li className="col-12 mb-1 ">
                                                  <Form.Group className="form-group">
                                                    <Form.Label>
                                                      {t('address')} <span style={{ color: "red" }}>*</span>{" "}
                                                    </Form.Label>
                                                    <Form.Control
                                                      type="text"
                                                      name="address"
                                                      value={formData.address}
                                                      onChange={handleChange}
                                                      className="mb-0 py-2"
                                                      id=""
                                                      placeholder={t('address')}
                                                      required
                                                    />
                                                  </Form.Group>
                                                </li>
                                              
                                                <li className="col-12 m-0 p-0">
                          <div className="row col-12 p-0 m-0">
                            <div className="col-6 p-0 pe-2 m-0">
                              <Form.Group className="form-group">
                                <Form.Label>
                                  {t("country")} <span style={{ color: "red" }}>*</span>{" "}
                                </Form.Label>
                                <Form.Select
                                  name="country"
                                  value={formData.country}
                                  onChange={(e) => {
                                    const selectedCountryName = e.target.value;
                                    setFormData({
                                      ...formData,
                                      country: selectedCountryName,
                                      state: "",
                                    });
                                  }}
                                  className="mb-0 py-2"
                                  required
                                >
                                  <option value="">{t("selectCountry")}</option>
                                  {Country.getAllCountries().map((country) => (
                                    <option key={country.isoCode} value={country.name}>
                                      {country.name}
                                    </option>
                                  ))}
                                </Form.Select>
                              </Form.Group>
                            </div>
                        
                            <div className="col-6 p-0 m-0">
                              <Form.Group className="form-group">
                                <Form.Label>
                                  {t("state")} <span style={{ color: "red" }}>*</span>{" "}
                                </Form.Label>
                                <Form.Select
                                  name="state"
                                  value={formData.state}
                                  onChange={handleChange}
                                  className="mb-0 py-2"
                                  required
                                  disabled={!formData.country}
                                >
                                  <option value="">{t("selectState")}</option>
                                  {formData.country &&
                                    State.getStatesOfCountry(getCountryCodeByName(formData.country)).map(
                                      (state) => (
                                        <option key={state.isoCode} value={state.name}>
                                          {state.name}
                                        </option>
                                      )
                                    )}
                                </Form.Select>
                              </Form.Group>
                            </div>
                          </div>
                        </li>
                        
                        
                                                <li className="col-12 m-0 p-0 ">
                                                <div className="row col-12 p-0 m-0 " >
                          <div className="col-6 p-0 pe-2 m-0 ">
                          
                            <Form.Group className="form-group">
                                                    <Form.Label>
                                                      {t('city')} <span style={{ color: "red" }}>*</span>{" "}
                                                    </Form.Label>
                                                    <Form.Control
                                                      type="text"
                                                      name="city"
                                                      value={formData.city}
                                                      onChange={handleChange}
                                                      className="mb-0 py-2"
                                                      id=""
                                                      placeholder={t('city')}
                                                      required
                                                    />
                                                  </Form.Group>
                          </div>
                          <div className="col-6 p-0 m-0">
                            <Form.Group className="form-group">
                              <Form.Label>
                                {t('pincode')} <span style={{ color: "red" }}>*</span>{" "}
                              </Form.Label>
                              <Form.Control
                                type="text"
                                name="zipCode"
                                value={formData.zipCode}
                                onChange={(e) => {
                                  const re = /^[0-9]{0,6}$/;
                                  if (re.test(e.target.value)) {
                                    setFormData(prevState => ({
                                      ...prevState,
                                      zipCode: e.target.value
                                    }));
                                  }
                                }}
                                className="mb-0 py-2"
                                placeholder={t('pincode')}
                                required
                              />
                            </Form.Group>
                          </div>
                        </div>
                        
                                              </li>
                                              <li className="col-12 p-0 m-0">
                                                                                <div className="row col-12 p-0 m-0">
                                                                                  <div className="col-6 p-0 pe-2 m-0">
                                                                                    <Form.Group className="form-group">
                                                                                      <Form.Label>
                                                                                        {t('mobile')} <span style={{ color: "red" }}>*</span>{" "}
                                                                                      </Form.Label>
                                                                                                                        <PhoneInput
                                        country={(user?.country || "us").toLowerCase()} 
                                                                                          value={formData.mobile}
                                                                                          onChange={(phone) => handlePhoneChange(phone, "mobile")}
                                                                                          inputStyle={{ width: "100%", paddingBlock:"20px" }}
                                                                                          required
                                                                                        />
                                                                                    </Form.Group>
                                                                                  </div>
                                                                                  <div className="col-6 p-0 m-0">
                                                                                    <Form.Group className="form-group">
                                                                                      <Form.Label>
                                                                                        {t('email_label')} <span style={{ color: "red" }}>*</span>{" "}
                                                                                      </Form.Label>
                                                                                      <Form.Control
                                                                                        type="email"
                                                                                        name="email"
                                                                                        value={formData.email}
                                                                                        onChange={handleChange}
                                                                                        className="mb-0 py-2"
                                                                                        id=""
                                                                                        placeholder={t('email_placeholder')}
                                                                                        required
                                                                                        
                                                                                      />
                                                                                    </Form.Group>
                                                                                  </div>
                                                                                </div>
                                                                              </li>
                        
                        <li className="col-12 mb-1">
                        
                          <Form.Label>
                          {t('image')} <span style={{ color: "red" }}>*</span>{" "}
                          </Form.Label>
                          <label
                            htmlFor="file-input"
                            style={{ cursor: "pointer", width: "100%" }}
                          >
                            <div
                              className="bg-soft-primary rounded p-1 pointer"
                              style={{
                                width: "100%",
                                textAlign: "center",
                                fontSize: "1.2rem",
                                position: "relative",
                                borderRadius: "10px",
                              }}
                            >
                              <input
                                id="file-input"
                                type="file"
                                name="image"
                                multiple
                                style={{ display: "none" }}
                                onChange={handleFileInputChange}
                              />
                              <span>
                                {selectedFile.length > 0 ? (
                                  <MdOutlineDone style={{ fontSize: "25px" }} />
                                ) : (
                                  <i className="fas fa-upload"></i>
                                )}
                              </span>
                              <p style={{ marginTop: ".5rem" }}>
                              {t('click_to_select_files')}
                              </p>
                            </div>
                          </label>
                          {imagePreview && imagePreview.length > 0 && (
                            <div className="mt-2">
                                {imagePreview.map((preview, index) => (
                                    <img key={index} src={preview} alt={`Selected ${index}`} style={{ width: '70px', borderRadius: '10px', marginBottom: '10px' }} />
                                ))}
                            </div>
                        )}
                        </li>
                      </ul>
                      {/* <hr /> */}

                      <button
                        type="submit"
                        className="btn btn-primary d-block w-100 mt-3"
                        onClick={handlePost}
                      >
                        {t('post')}
                      </button>
                    </Modal.Body>
                  </Modal>
                  <Modal
size="md" centered
className="fade"
show={showModal}
onHide={handleCloseModal}
style={{ marginTop: "100px", maxHeight: "80vh" }}
>
<Modal.Header className="d-flex justify-content-between">
  <Modal.Title id="post-modalLabel">
    {t('contact_information')}
  </Modal.Title>
</Modal.Header>
<Modal.Body>
  <div>
    {contactInfo.email && (
      <p>
        <strong>{t("email_label")}: </strong>
        <a href={`mailto:${contactInfo.email}`} style={{ textDecoration: 'none' }}>
          {contactInfo.email}
        </a>
        <CiMail 
          size={20} 
          style={{ marginRight: "5px", fontWeight: "600", marginLeft: "10px", cursor: "pointer" }} 
          onClick={() => window.location.href = `mailto:${contactInfo.email}`} 
        />
      </p>
    )}

    {contactInfo.phone && (
      <p>
        <strong>{t("phone_label")}: </strong>
        <a href={`tel:${contactInfo.phone}`} style={{ textDecoration: 'none' }}>
          + {contactInfo.phone}
        </a>
        <IoCallOutline 
          size={18} 
          style={{ marginRight: "5px", marginLeft: "10px", cursor: "pointer" }} 
          onClick={() => window.location.href = `tel:${contactInfo.phone}`} 
        />
      </p>
    )}

    {!contactInfo.email && !contactInfo.phone && (
      <p>{t("contactInformationNotAvailable")}</p>
    )}
    <button
      type="button"
      className="btn btn-primary d-block w-100 mt-3"
      onClick={handleCloseModal}
    >
      {t('close')}
    </button>
  </div>
</Modal.Body>
</Modal>
                </Card>
              </Col>
              <Sponsored1 />

              <InfiniteScroll
              style={{overflowX:"hidden"}}
                dataLength={post.length}
                next={() => setPage((page) => page + 1)}
                hasMore={page<totalPages}
                loader={
                  <div className="col-sm-12 text-center">
                    <img
                      src={loader}
                      alt="loader"
                      style={{ height: "100px" }}
                    />
                  </div>
                }
                endMessage={entertainment?.length!==0 && (<p className="text-center">{t('no_more_posts')}</p>)}
              >
                {entertainment?.length === 0 ? (
                  <div>{t('no_posts_yet')}</div>
                ) : (
                  entertainment?.map((data, index) => (
                    <Col sm={12} key={index}>
                      <Card className=" card-block card-stretch card-height boxcard">
                        <Card.Body>
                          <div className="container_enter">
                            <div className="container_a">
                            <div style={{ display:"flex",width: "180px", minHeight: "180px", margin:"10px", width:"25%", alignItems:"center" }}>
                                <Carousel
                                  showArrows={false}
                                  showThumbs={false}
                                  showStatus={false}
                                  infiniteLoop
                                  autoPlay
                                  interval={2000}
                                >
                                  {data?.photos?.map((image) => (
                                    <div>
                                      <img
          src={image ? image : "/profile.png"}
          className="rounded image_enter"
          alt="Responsive"
          onError={(e) => { e.target.onerror = null; e.target.src = "/profile.png"; }}
        />
                                    </div>
                                  ))}
                                </Carousel>
                              </div>
                              <div style={{margin:"10px", display:"flex", width:"45%", flexDirection:"column"}}>
                                <h2 className="text-primary">{data?.title}</h2>
                                <div dangerouslySetInnerHTML={{ __html: data?.description }} />
                                  <span className="heading" style={{marginTop:"-10px"}}>{t('category')}: <span className="head">{data?.saleCategory}</span></span>
                                  {data?.location ? (<span className="heading">{t('location')}: <span className="head">{data?.location?.address}, {data?.location?.city}, {data?.location?.state}, {data?.location?.country}, {data?.location?.zipCode}</span></span>): (<div></div>)}
                                  <span className="heading">{t('condition')}: <span className="head">{data?.condition}</span></span>
                              </div>
                              <div style={{ display:"flex", width:"30%", flexDirection:"column", borderLeft:"1px solid #d4d4d4",padding:"10px", height:"100%", background:"rgb(248,248,248)"}}>
                                <h4 className="" >{data?.userId?.firstName} {data?.userId?.lastName}<BsPatchCheckFill style={{color:"green", marginInline:"10px"}}/>
</h4>
                                {/* <div>Raja Garden, Delhi</div> */}
                                {/* <span className="heading" style={{display:"flex", color:"blue", marginBlock:"10px"}}><span ><CiGlobe size={16} style={{marginRight:"5px",marginTop:"-2px"}}/>{t('website')}</span></span> */}
                                <div className="buttonsection">
                                <button className="buttonsend" onClick={()=>handleOpenModal(data?.contactInfo)}><CiMail size={20} style={{marginRight:"5px", fontWeight:"600"}}/>{t('send_enquiry')}</button>
  {/* <button className="buttonsend"><CiMail size={20} style={{marginRight:"5px", fontWeight:"600"}}/>{t('send_enquiry')}</button>
  <button className="constbutton"><IoCallOutline size={18} style={{marginRight:"5px"}}/>{t('contact')}</button> */}
</div>
                              </div>
                            </div>
                          </div>
                              {/* <div>njdhsb</div> */}
                        </Card.Body>
                      </Card>
                    </Col>
                  ))
                )}
              </InfiniteScroll>
            </Col>
                  </Tab.Pane>
                  <Tab.Pane eventKey="f2">
                  <Col lg={12} className="row m-0 p-0">
              <Col sm={12}>
                <Card
                  id="post-modal-data"
                  className="card-block card-stretch card-height"
                >
                  <div className="card-header d-flex justify-content-between">
                    <div className="header-title">
                      <h4 className="card-title">{t('createPostForSale')}</h4>
                    </div>
                  </div>
                  <Card.Body>
                    <div className="d-flex align-items-center">
                      <div className="user-img">
                        <img
                        src={profileImage}
                          // src={`${user?.profileImageLink ? user?.profileImageLink : '/profile.png'}`}
                          alt="user1"
                          className="avatar-60 rounded-circle"
                        />
                      </div>
                      <form
                        className="post-text ms-3 w-100 "
                        onClick={handleShow}
                      >
                        <input
                          type="text"
                          className="form-control rounded"
                          placeholder={t('writeSomethingHere')}
                          style={{ border: "none" }}
                        />
                      </form>
                    </div>
                    
                  </Card.Body>
                 
                </Card>
              </Col>
              <Sponsored1 />

              <InfiniteScroll
              style={{overflowX:"hidden"}}
                dataLength={post.length}
                next={() => setPage((page) => page + 1)}
                hasMore={page<totalPages}
                loader={
                  <div className="col-sm-12 text-center">
                    <img
                      src={loader}
                      alt="loader"
                      style={{ height: "100px" }}
                    />
                  </div>
                }
                endMessage={entertainment?.length!==0 && (<p className="text-center">{t('no_more_posts')}</p>)}
              >
                {entertainment?.length === 0 ? (
                  <div>{t('no_posts_yet')}</div>
                ) : (
                  entertainment?.map((data, index) => (
                    <Col sm={12} key={index}>
                      <Card className=" card-block card-stretch card-height boxcard">
                        <Card.Body>
                          <div className="container_enter">
                            <div className="container_a">
                            <div style={{ display:"flex",width: "180px", minHeight: "180px", margin:"10px", width:"25%", alignItems:"center" }}>
                                <Carousel
                                  showArrows={false}
                                  showThumbs={false}
                                  showStatus={false}
                                  infiniteLoop
                                  autoPlay
                                  interval={2000}
                                >
                                  {data?.photos?.map((image) => (
                                    <div>
                                      <img
          src={image ? image : "/profile.png"}
          className="rounded image_enter"
          alt="Responsive"
          onError={(e) => { e.target.onerror = null; e.target.src = "/profile.png"; }}
        />
                                    </div>
                                  ))}
                                </Carousel>
                              </div>
                              <div style={{margin:"10px", display:"flex", width:"45%", flexDirection:"column"}}>
                                <h2 className="text-primary">{data?.title}</h2>
                                <div dangerouslySetInnerHTML={{ __html: data?.description }} />
                                  <span className="heading" style={{marginTop:"-10px"}}>{t('category')}: <span className="head">{data?.saleCategory}</span></span>
                                  {data?.location ? (<span className="heading">{t('location')}: <span className="head">{data?.location?.address}, {data?.location?.city}, {data?.location?.state}, {data?.location?.country}, {data?.location?.zipCode}</span></span>): (<div></div>)}
                                  <span className="heading">{t('condition')}: <span className="head">{data?.condition}</span></span>
                              </div>
                              <div style={{ display:"flex", width:"30%", flexDirection:"column", borderLeft:"1px solid #d4d4d4",padding:"10px", height:"100%", background:"rgb(248,248,248)"}}>
                                <h4 className="" >{data?.userId?.firstName} {data?.userId?.lastName}<BsPatchCheckFill style={{color:"green", marginInline:"10px"}}/>
</h4>
                                {/* <div>Raja Garden, Delhi</div> */}
                                {/* <span className="heading" style={{display:"flex", color:"blue", marginBlock:"10px"}}><span ><CiGlobe size={16} style={{marginRight:"5px",marginTop:"-2px"}}/>{t('website')}</span></span> */}
                                <div className="buttonsection">
                                <button className="buttonsend" onClick={()=>handleOpenModal(data?.contactInfo)}><CiMail size={20} style={{marginRight:"5px", fontWeight:"600"}}/>{t('send_enquiry')}</button>
  {/* <button className="buttonsend"><CiMail size={20} style={{marginRight:"5px", fontWeight:"600"}}/>{t('send_enquiry')}</button>
  <button className="constbutton"><IoCallOutline size={18} style={{marginRight:"5px"}}/>{t('contact')}</button> */}
</div>
                              </div>
                            </div>
                          </div>
                              {/* <div>njdhsb</div> */}
                        </Card.Body>
                      </Card>
                    </Col>
                  ))
                )}
              </InfiniteScroll>
            </Col>
                  </Tab.Pane>
                </Tab.Content>
              </Tab.Container>
            </Col>

          </Row>
        </Container>
      </div>
    </>
  );
};
const styles = {
  loaderOverlay: {
    position: "fixed",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    backgroundColor: "rgba(0, 0, 0, 0.6)",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    zIndex: 9999,
  },
};
export default ForSale;
